import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

class SwitchInput extends Component {
  static displayName = 'SwitchInput';
  static propTypes = {
    value: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }
  onChange() {
    var value = !this.props.value;
    this.props.onChange(value);
  }
  render() {
    var { value } = this.props;
    var className = classnames('enabled', {
      disabled: !value
    });

    var switchClassName = 'switch';
    if (this.props.className) {
      switchClassName += ` ${this.props.className}`;
    }
    return (
      <div className="switch-with-label">
        <div className={switchClassName}>
          <label className="green-switch">
            <input
              type="checkbox"
              className="switch-input"
              onChange={this.onChange}
              checked={value}
            />
            <span className="switch-label" />
            <span className="switch-handle" />
          </label>
        </div>
        <span onClick={this.onChange} className={className} />
      </div>
    );
  }
}

export default SwitchInput;
